import {
  MATCH_REASON_LABELS,
  type SummerCampaignLeadMatchReason,
} from "@shared/helpers/summer-campaign-lead-admin";
import { linko } from "@shared/linko";

type ListLeadsData = Awaited<
  ReturnType<typeof linko.summerCampaignLead.queries.listLeads>
>["data"];

export type SummerCampaignLeadRow = ListLeadsData extends { items: infer Items }
  ? Items extends Array<infer Row>
    ? Row
    : never
  : ListLeadsData extends Array<infer Row>
    ? Row
    : never;

export const LEADS_PAGE_SIZE = 50;

export function formatMatchReasons(reasons?: SummerCampaignLeadMatchReason[]) {
  if (!reasons?.length) return "";
  return reasons.map((r) => MATCH_REASON_LABELS[r]).join(" · ");
}

export function exportLeadsToCsv(
  leads: Array<Record<string, unknown>>,
  filename = "summer-campaign-leads.csv",
) {
  if (!leads.length) return;
  const headers = [
    "phoneNumber",
    "regionLabel",
    "attendanceLabel",
    "teamNames",
    "categoryNames",
    "status",
    "contactStatusLabel",
    "registrationCount",
    "submittedAt",
  ];
  const rows = leads.map((lead) =>
    headers
      .map((key) => {
        const value = lead[key];
        const text = Array.isArray(value) ? value.join("; ") : String(value ?? "");
        return `"${text.replace(/"/g, '""')}"`;
      })
      .join(","),
  );
  const csv = [headers.join(","), ...rows].join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
